import { app } from '../../../../app';
import { Controller } from './idp-authenticator-add.controller';

app.component('companyIdpAuthenticatorsAdd', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticator-add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/add/idp-authenticator-add.component.js